/**
 * Mirrors `hasPurchasePriceForMargin` in `services/marginService.ts`.
 * Operating margin is only meaningful when unit COGS is known and positive.
 */
export function hasPurchasePriceForMargin(purchaseRaw: unknown): boolean {
  if (purchaseRaw == null || purchaseRaw === '') return false;
  const n = typeof purchaseRaw === 'number' ? purchaseRaw : parseFloat(String(purchaseRaw).trim());
  return Number.isFinite(n) && n > 0;
}

/** Positive purchase price for formulas, or null if unknown / invalid. */
export function purchasePriceNumericOrNull(purchaseRaw: unknown): number | null {
  if (!hasPurchasePriceForMargin(purchaseRaw)) return null;
  return typeof purchaseRaw === 'number' ? purchaseRaw : parseFloat(String(purchaseRaw).trim());
}
